module.exports = __webpack_public_path__ + "img/close_btn_white.375c8b21.svg";